import { AuthService } from "@services/auth.service";

import { inject } from "@angular/core";
import { type CanActivateFn, Router } from "@angular/router";

export const onboardingAccessGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isSessionValid = await authService.ensureValidSession();
  return isSessionValid || router.parseUrl("/login");
};
